/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SharedStreakLeaveResponse
 */
export interface SharedStreakLeaveResponse {
    /**
     * 
     * @type {string}
     * @memberof SharedStreakLeaveResponse
     */
    message: string;
}

/**
 * Check if a given object implements the SharedStreakLeaveResponse interface.
 */
export function instanceOfSharedStreakLeaveResponse(value: object): value is SharedStreakLeaveResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function SharedStreakLeaveResponseFromJSON(json: any): SharedStreakLeaveResponse {
    return SharedStreakLeaveResponseFromJSONTyped(json, false);
}

export function SharedStreakLeaveResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedStreakLeaveResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function SharedStreakLeaveResponseToJSON(json: any): SharedStreakLeaveResponse {
    return SharedStreakLeaveResponseToJSONTyped(json, false);
}

export function SharedStreakLeaveResponseToJSONTyped(value?: SharedStreakLeaveResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

